import countries from "../../data/countries.json";
import {useContext, useState} from "react";
import {AppContext} from "../../App";
import {postRequest} from "../../helpers/APIHelper";
import Loading from "../Loading";
import TextInput from "../Form/input/TextInput";
import Select from "../Form/select/Select";
import PreferredTitleSelect from "../Form/select/PreferredTitleSelect";
import Checkbox from "../Form/checkbox/Checkbox";

function ContactForm({propertyRef = ""}) {
    const ref = propertyRef;

    const {setToastIsOpen, setToastMessage, setContactModalIsOpen, setToastType} = useContext(AppContext);

    const [preferredTitle, setPreferredTitle] = useState("");
    const [lastName, setLastName] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState(null);
    const [rgpd, setRgpd] = useState(false);

    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();

        let contactForm = {
            preferredTitle: preferredTitle,
            lastName: lastName,
            name: name,
            email: email,
            phone: phone,
            address: address,
            postalCode: postalCode,
            city: city,
            country: country,
            message: message,
            rgpd: rgpd,
            link: window.location.href
        }

        if (ref !== "") {
            contactForm.ref = ref;
        }


        setLoading(true);
        const {data, error} = await postRequest({endpoint: "/contact", body: contactForm});
        setLoading(false);

        if (error) {
            setErrors(error);
        } else if (data.data.sent) {
            setContactModalIsOpen(false);
            setToastMessage("Votre demande a été envoyée!");
            setToastType("sent");
            setToastIsOpen(true);
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="flex justify-center mb-6">
                <div className="w-1/2">
                <PreferredTitleSelect id="preferredTitle"
                              value={preferredTitle} setValue={setPreferredTitle} title="Titre" required={true}
                              initialError={(errors && "preferredTitle" in errors) ? errors.preferredTitle[0] : null}
                />
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 mb-6">
                <TextInput id="lastName"
                           required={true}
                           value={lastName}
                           setValue={setLastName}
                           title="Nom"
                           initialError={(errors && "lastName" in errors) ? errors.lastName[0] : null}/>
                <TextInput id="name"
                           required={true}
                           value={name}
                           setValue={setName}
                           title="Prénom"
                           initialError={(errors && "name" in errors) ? errors.name[0] : null}/>
                <TextInput type="email"
                           id="email"
                           required={true}
                           value={email}
                           setValue={setEmail}
                           title="Adresse e-mail"
                           initialError={(errors && "email" in errors) ? errors.email[0] : null}/>
                <TextInput type="phone"
                           id="phone"
                           value={phone}
                           setValue={setPhone}
                           title="Téléphone (avec indicatif)"
                           initialError={(errors && "phone" in errors) ? errors.phone[0] : null}/>
                <TextInput id="address"
                           value={address}
                           required={true}
                           setValue={setAddress}
                           title="Adresse"
                           initialError={(errors && "address" in errors) ? errors.address[0] : null}/>
                <TextInput type="number"
                           id="postalCode"
                           value={postalCode}
                           required={true}
                           setValue={setPostalCode}
                           title="Code postal"
                           initialError={(errors && "postalCode" in errors) ? errors.postalCode[0] : null}/>
                <TextInput id="city"
                           value={city}
                           required={true}
                           setValue={setCity}
                           title="Ville"
                           initialError={(errors && "city" in errors) ? errors.city[0] : null}/>
                <Select id="country"
                        value={country}
                        setValue={setCountry}
                        title="Pays"
                        required={true}
                        options={countries.map((country) => ({value: country.name, title: country.name}))}/>
            </div>
            <TextInput id="message"
                       type="textarea"
                       setValue={setMessage}
                       value={message}
                       required={true}
                       initialError={(errors && "message" in errors) ? errors.message[0] : null}
                       title="Votre message"/>
            <div className="mt-6">
                <Checkbox id="rgpd" required={true} initialError={(errors && "rgpd" in errors) ? errors.rgpd[0] : null}
                          value={rgpd} setValue={setRgpd} />
            </div>
            <div className="flex justify-center pt-10 pb-5">
                <button type="submit"
                        className="text-white bg-primary hover:bg-primary-light focus:ring-4 focus:outline-none focus:ring-primary-light font-medium text-md w-full sm:w-auto px-5 py-2.5 text-center">
                    {loading ? <Loading page={false}/> : "Envoyer ma demande"}
                </button>
            </div>
        </form>
    );
}

export default ContactForm;
